import CollageStrips from '../../shared/CollageStrips/CollageStrips';
import MainButton from '../../shared/MainButton/MainButton';
import Typography, { FONT_TYPES } from '../../shared/Typography/Typography';

import { FINAL_COLLAGE } from '../../../../config/collages';

import buildVisitUrl from '../../../../utils/buildVisitUrl';

import confetti from '../../../../images/quiz/confetti.png';
import kismiaCrown from '../../../../images/quiz/kismia_crown.png';

import styles from './Final.module.scss';

const Final = ({ texts }) => {
  const handleVisitClick = () => {
    window.location.href = buildVisitUrl(window.location.search);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.bg}>
        <CollageStrips images={FINAL_COLLAGE} rowsCount={8} className={styles.collage} />
        <div className={styles.overlay} />
      </div>
      <div className={styles.content}>
        <div className={styles.card}>
          <Typography type={FONT_TYPES.brand} htmlTag="p" className={styles.brand} isCenter>
            MatchMaker
          </Typography>
          <Typography
            type={FONT_TYPES.body_regular}
            htmlTag="p"
            className={styles.title}
            isCenter
          >
            {texts.final.title}
          </Typography>
          <div className={styles.productBadge}>
            <img src={confetti} alt="" className={styles.confetti} />
            <img src={kismiaCrown} alt="Kismia" className={styles.kismia} />
          </div>
          <MainButton onClick={handleVisitClick}>{texts.final.cta}</MainButton>
        </div>
      </div>
    </div>
  );
};

export default Final;
